import { type ReactNode } from 'react'
import { useScrollOffsets } from '@/hooks/element-hooks'
import { Sandwich, SandwichBun, SandwichContent } from '@/components/Sandwich'
import { ContentLayout, ContentMain } from '@/components/ContentLayout'
import { ContentError } from '@/components/ContentError'
import { ListHeader } from '@/components/ListHeader'
import { PayoutsAdminHeader } from '@/features/payouts/admin/components/PayoutsAdminHeader'

export interface TransactionHistoryProps {
  canAccess: boolean
  transactionsCount: number
  children?: ReactNode
}

export function TransactionHistory({
  canAccess,
  transactionsCount,
  children,
}: TransactionHistoryProps) {
  const { connectRef: scrollRef, scrollYStart: scrollOffset } =
    useScrollOffsets()

  if (!canAccess) {
    return (
      <ContentError
        title="Denied"
        size="lg"
        error="You are not allowed to access this page."
      />
    )
  }

  return (
    <Sandwich stretch>
      <SandwichBun>
        <PayoutsAdminHeader scrollOffset={scrollOffset} />
      </SandwichBun>
      <SandwichContent stretch>
        <ContentLayout accountForLabel accountForTabBar fill ref={scrollRef}>
          <ContentMain fill constrainWidth>
            <Sandwich stretch>
              <SandwichBun>
                <ListHeader count={transactionsCount || undefined}>
                  Paid out transactions
                </ListHeader>
              </SandwichBun>
              <SandwichContent stretch>{children}</SandwichContent>
            </Sandwich>
          </ContentMain>
        </ContentLayout>
      </SandwichContent>
    </Sandwich>
  )
}
